/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup>): BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup(), model);
        BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup>): BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup.newInstance(<BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
